// 4. Main container component
// src/components/Timeline/TimelineContainer.tsx
import React, { useState } from 'react';
import { Box } from '@mui/material';
import TimelineHeader from './TimelineHeader';
import TimelineFeed from './TimelineFeed';
import TimelineCompactView from './TimelineCompactView';
import TimelineChronology from './TimelineChronology';
import TimelineImageDialog from './components/TimelineImageDialog';
import TimelineCollaborators from './components/TimelineCollaborators';
import { useTimelineData } from './types';
import { useImageViewer } from './hooks/useImageViewer';
import { TimelineViewProps, TimelineViewType } from './types';

const TimelineContainer: React.FC<TimelineViewProps> = (props) => {
   const [view, setView] = useState<string>('timeline');
   const [currentTab, setCurrentTab] = useState(0);
   const [showCollaborators, setShowCollaborators] = useState(false);
   const { canUserAccess } = props;
   // Use our custom hooks
   const timelineData = useTimelineData(props);
   const {
      imageDialogOpen,
      currentImages,
      currentImageIndex,
      openImageDialog,
      closeImageDialog,
      handleNextImage,
      handlePrevImage,
   } = useImageViewer();

   return (
      <Box>
         <TimelineHeader
            canUserAccess={canUserAccess}
            startDate={props.startDate}
            endDate={props.endDate}
            tripName={props.tripName}
            tripStatus={timelineData.tripStatus}
            isPastTrip={timelineData.isPastTrip}
            collaborators={props.collaborators || []}
            view={view}
            onViewChange={setView}
            onShowCollaborators={() => setShowCollaborators(true)}
         />

         {view === 'feed' && (
            <TimelineFeed
               {...props}
               {...timelineData}
               events={props.events || []}
               transportations={props.transportations || []}
               openImageDialog={openImageDialog}
               onShowCollaborators={() => setShowCollaborators(true)}
            />
         )}

         {view === 'day' && (
            <TimelineCompactView
               {...props}
               {...timelineData}
               currentTab={currentTab}
               onTabChange={setCurrentTab}
               openImageDialog={openImageDialog}
            />
         )}

         {view === 'timeline' && (
            <TimelineChronology
               {...props}
               {...timelineData}
               onDaySelect={(index) => {
                  setCurrentTab(index);
                  setView('compact');
               }}
               openImageDialog={openImageDialog}
            />
         )}

         <TimelineImageDialog
            open={imageDialogOpen}
            images={currentImages}
            currentIndex={currentImageIndex}
            onClose={closeImageDialog}
            onNext={handleNextImage}
            onPrev={handlePrevImage}
         />

         <TimelineCollaborators
            open={showCollaborators}
            collaborators={props.collaborators || []}
            onClose={() => setShowCollaborators(false)}
         />
      </Box>
   );
};

export default TimelineContainer;
